import React, {FC, useCallback} from 'react'
import {Col, Row} from 'antd'
import moment from 'moment'
import  './index.scss'
import SvgPanelClose from "assets/images/icons/SvgPanelClose";
import {financial} from "../../../../services/helper";
import { useTranslation } from 'react-i18next';

interface RowItemProps {
    label: string;
    text: string;
}

interface RowProps {
    // tableData: Deposit
    leftItems: RowItemProps[];
    tableData: RowItemProps[];
    handleRowClose: any
    labelStyle?: string
    styleCreditRowColum?: object
    styleCreditRowColumLeft?: object
}



export const CreditRowItem: FC<RowProps> = ({ labelStyle, tableData, handleRowClose, styleCreditRowColum, styleCreditRowColumLeft }: RowProps) => {
    const {t} = useTranslation()
    console.log('creditrowitem')
    console.log(tableData)
    return (
        <div className={`creditRow`}>
        <Row>
        <Col span={10} offset={2}>
            <div className={`creditRow__colum`} style={styleCreditRowColum}>
                <div key={1} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("accounts.branch")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.BRANCH_NAME}</p>
                </div>
                <div key={2} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.loanAmount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.CREDIT_AMOUNT ? financial(tableData?.CREDIT_AMOUNT) : 0.00}</p>
                </div>
                <div key={3} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.disbursementDate")}</p>
                    <p className={'creditRow__colum-item--text'}>{moment(tableData?.START_DATE,'DD/MM/YYYY').format('DD.MM.YYYY')}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("salary.expiryDate")}</p>
                    <p className={'creditRow__colum-item--text'}>{moment(tableData?.END_DATE,'DD/MM/YYYY').format('DD.MM.YYYY')}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.interestRate")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.INT_RATE}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.repaymentAccount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.PAYMENT_ACCOUNT}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.balanceOfRepaymentAccount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.PAYMENT_ACC_BALANCE ? financial(tableData?.PAYMENT_ACC_BALANCE) :  0.00}</p>
                </div>
            </div>
            </Col>
            <Col span={12}>
            <div className={`creditRow__colum`} style={styleCreditRowColumLeft}>
                <div key={1} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.totalAmountOfInterest")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.TOTAL_INT_AMOUNT ? financial(tableData?.TOTAL_INT_AMOUNT) : '0.00'}</p>
                </div>
                <div key={2} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{`${t("credits.paidInterestAmount.up")} ${t("credits.paidInterestAmount.down")}`}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.PAID_INT_AMOUNT ?  financial(tableData?.PAID_INT_AMOUNT ) : '0.00'}</p>
                </div>
                <div key={3} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.currentInterestAmount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.CUR_INT_AMOUNT ? financial(tableData?.CUR_INT_AMOUNT) : '0.00'}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.numberOfDaysTillRepaymentDate")}</p>
                    <p className={'creditRow__colum-item--text'}>{0}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.totalDelayedAmount")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.TOTAL_DELAY_AMOUNT ? financial(tableData?.TOTAL_DELAY_AMOUNT): '0.00'}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.numberOfDelayedDays")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.DELAY_DAY_COUNT}</p>
                </div>
                <div key={4} className={'creditRow__colum-item'}>
                    <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("credits.accruedPenalties")}</p>
                    <p className={'creditRow__colum-item--text'}>{tableData?.CALCULATED_PENALTY ? financial(tableData?.CALCULATED_PENALTY) : '0.00'}</p>
                </div>
            </div>
            </Col>
            </Row>
            <a onClick={() => handleRowClose()} className={'creditRow__closeBtn'}><SvgPanelClose/></a>
        </div>
     
    );
};

// export const CreditRowItem: FC<RowProps> = ({tableData,labelStyle, handleRowClose, styleCreditRowColum, styleCreditRowColumLeft}: RowProps) => {
//     return (
//         <div className={`creditRow`}>
//             <div className={`creditRow__colum`} style={styleCreditRowColum}>
//                 <div key={1} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>{t("accounts.branch")}</p>
//                     <p className={'creditRow__colum-item--text'}>{tableData?.BRANCH_NAME}</p>
//                 </div>
//                 <div key={2} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>Müddət, ay</p>
//                     <p className={'creditRow__colum-item--text'}>{Number(tableData?.periodYear)*12 + tableData?.periodMonth}</p>
//                 </div>
//                 <div key={3} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>İlkin məbləğ</p>
//                     <p className={'creditRow__colum-item--text'}>{tableData?.INITIALAMOUNT}</p>
//                 </div>
//                 <div key={4} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>Gəlir vergisinin məbləği</p>
//                     <p className={'creditRow__colum-item--text'}>00.00</p>
//                 </div>
//             </div>
//             <div className={'creditRow__colum'} style={styleCreditRowColumLeft}>
//
//                 <div key={1} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>Faizlərin ödənilməsi sxemi</p>
//                     <p className={'creditRow__colum-item--text'}>{tableData?.PAYMENTPERIOD}</p>
//                 </div>
//                 <div key={2} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>Faizlərin köçürüldüyü hesab</p>
//                     <p className={'creditRow__colum-item--text'}>{tableData.INTEREST_ACC}</p>
//                 </div>
//                 <div key={3} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>Hesablanmış faiz məbləği</p>
//                     <p className={'creditRow__colum-item--text'}>00.00</p>
//                 </div>
//                 <div key={4} className={'creditRow__colum-item'}>
//                     <p className={`creditRow__colum-item--label ${labelStyle}`}>{`${t("credits.paidInterestAmount.up")} ${t("credits.paidInterestAmount.down")}`}</p>
//                     <p className={'creditRow__colum-item--text'}>00.00</p>
//                 </div>
//
//             </div>
//             <a onClick={() => handleRowClose()} className={'creditRow__closeBtn'}><SvgPanelClose/></a>
//         </div>
//     );
// };
